import { render, staticRenderFns } from "./news-tags.vue?vue&type=template&id=1dc0bc7c&lang=pug&"
import script from "./news-tags.vue?vue&type=script&lang=js&"
export * from "./news-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports